/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TableLinks.vue?vue&type=template&id=2d64f02e&scoped=true"
import script from "./TableLinks.vue?vue&type=script&lang=js"
export * from "./TableLinks.vue?vue&type=script&lang=js"
import style0 from "./TableLinks.vue?vue&type=style&index=0&id=2d64f02e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64f02e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d64f02e')) {
      api.createRecord('2d64f02e', component.options)
    } else {
      api.reload('2d64f02e', component.options)
    }
    module.hot.accept("./TableLinks.vue?vue&type=template&id=2d64f02e&scoped=true", function () {
      api.rerender('2d64f02e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/partials/TableLinks.vue"
export default component.exports